/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateParametroFormDto } from '../models/create-parametro-form-dto';
import { ParametroCriteriaDto } from '../models/parametro-criteria-dto';
import { ParametroDto } from '../models/parametro-dto';
import { ParametroPageDto } from '../models/parametro-page-dto';
import { UpdateParametroFormDto } from '../models/update-parametro-form-dto';


/**
 * Parametros de sistema
 */
@Injectable({
  providedIn: 'root',
})
export class ParametrosService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getParametros
   */
  static readonly GetParametrosPath = '/parametros';

  /**
   * Pesquisar parâmetros de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getParametros()` instead.
   *
   * This method doesn't expect any request body.
   */
  getParametros$Response(params?: {
    criteria?: ParametroCriteriaDto;
  }): Observable<StrictHttpResponse<ParametroPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParametrosService.GetParametrosPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametroPageDto>;
      })
    );
  }

  /**
   * Pesquisar parâmetros de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getParametros$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getParametros(params?: {
    criteria?: ParametroCriteriaDto;
  }): Observable<ParametroPageDto> {

    return this.getParametros$Response(params).pipe(
      map((r: StrictHttpResponse<ParametroPageDto>) => r.body as ParametroPageDto)
    );
  }

  /**
   * Path part for operation createParametro
   */
  static readonly CreateParametroPath = '/parametros';

  /**
   * Criar parâmetro de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createParametro()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createParametro$Response(params?: {

    /**
     * apiRequest
     */
    body?: CreateParametroFormDto
  }): Observable<StrictHttpResponse<ParametroDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParametrosService.CreateParametroPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametroDto>;
      })
    );
  }

  /**
   * Criar parâmetro de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createParametro$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createParametro(params?: {

    /**
     * apiRequest
     */
    body?: CreateParametroFormDto
  }): Observable<ParametroDto> {

    return this.createParametro$Response(params).pipe(
      map((r: StrictHttpResponse<ParametroDto>) => r.body as ParametroDto)
    );
  }

  /**
   * Path part for operation getParametro
   */
  static readonly GetParametroPath = '/parametros/{id}';

  /**
   * Obter parâmetro de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getParametro()` instead.
   *
   * This method doesn't expect any request body.
   */
  getParametro$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ParametroDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParametrosService.GetParametroPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametroDto>;
      })
    );
  }

  /**
   * Obter parâmetro de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getParametro$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getParametro(params: {
    id: number;
  }): Observable<ParametroDto> {

    return this.getParametro$Response(params).pipe(
      map((r: StrictHttpResponse<ParametroDto>) => r.body as ParametroDto)
    );
  }

  /**
   * Path part for operation updateParametro
   */
  static readonly UpdateParametroPath = '/parametros/{id}';

  /**
   * Alterar parâmetro de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateParametro()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateParametro$Response(params: {
    id: number;
    body?: UpdateParametroFormDto
  }): Observable<StrictHttpResponse<ParametroDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParametrosService.UpdateParametroPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametroDto>;
      })
    );
  }

  /**
   * Alterar parâmetro de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateParametro$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateParametro(params: {
    id: number;
    body?: UpdateParametroFormDto
  }): Observable<ParametroDto> {

    return this.updateParametro$Response(params).pipe(
      map((r: StrictHttpResponse<ParametroDto>) => r.body as ParametroDto)
    );
  }

  /**
   * Path part for operation ativarParametro
   */
  static readonly AtivarParametroPath = '/parametros/{id}/ativar';

  /**
   * Ativar parâmetro de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarParametro()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarParametro$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ParametroDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParametrosService.AtivarParametroPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametroDto>;
      })
    );
  }

  /**
   * Ativar parâmetro de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarParametro$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarParametro(params: {
    id: number;
  }): Observable<ParametroDto> {

    return this.ativarParametro$Response(params).pipe(
      map((r: StrictHttpResponse<ParametroDto>) => r.body as ParametroDto)
    );
  }

  /**
   * Path part for operation desativarParametro
   */
  static readonly DesativarParametroPath = '/parametros/{id}/desativar';

  /**
   * Desativar parâmetro de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarParametro()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarParametro$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ParametroDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParametrosService.DesativarParametroPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametroDto>;
      })
    );
  }

  /**
   * Desativar parâmetro de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarParametro$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarParametro(params: {
    id: number;
  }): Observable<ParametroDto> {

    return this.desativarParametro$Response(params).pipe(
      map((r: StrictHttpResponse<ParametroDto>) => r.body as ParametroDto)
    );
  }

}
